const moment = require("moment");

const MomentUtils = () => {
}

export const addMoment = (addingNumber, addingKeyword) => {
    return moment().add(addingNumber, addingKeyword);
}

export const formatMoment = (time, formatString) => {
    return moment(time).format(formatString);
}

export const momentSubtract = (dateSubtract, subtractNumber, subtractKeyword) => {
    return moment(dateSubtract).subtract(subtractNumber, subtractKeyword).toISOString();
}

export const setCurrentTime = (minutes, addingNumber, addingKeyword) => {
    return moment(new Date().setMinutes(minutes)).add(addingNumber, addingKeyword);
}

export const setNewDate = (newDate, hours, minutes, seconds) => {
    return moment(newDate).hours(hours).minutes(minutes).seconds(seconds);
}

export const getMinDate = (eventStartDate, subtractNumber, subtractKeyword, minutes) => {
    return moment(Math.min(eventStartDate)).subtract(subtractNumber, subtractKeyword).minutes(minutes).toDate();
}

export const getMaxDate = (eventStartDate, addNumber, addKeyword) => {
    return moment(Math.max(eventStartDate)).add(addNumber, addKeyword).toDate();
}

export default MomentUtils;